module.exports = __webpack_public_path__ + "img/banner.88315ed7.png";